var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outlined/Chevron Right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.86033 3.52295C7.11877 3.271 7.53777 3.271 7.79621 3.52295L13.9727 9.54445C14.2311 9.7964 14.2311 10.2049 13.9727 10.4568L7.79621 16.4784C7.53777 16.7303 7.11877 16.7303 6.86033 16.4784C6.6019 16.2264 6.6019 15.8179 6.86033 15.566L12.5689 10.0007L6.86033 4.43534C6.6019 4.18339 6.6019 3.7749 6.86033 3.52295Z",
    fill: "#005C5D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/Chevron Right.ce74b8d49cc2957f9c9147a9b3e4c968.svg";
export { ForwardRef as ReactComponent };